<template>
  <div class="modal fade" id="editParameterNamesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Parameter Names</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="save">
            <div class="mb-3">
              <label class="form-label">Parameter 1</label>
              <input v-model="localTitles[0]" type="text" class="form-control" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Parameter 2</label>
              <input v-model="localTitles[1]" type="text" class="form-control" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Parameter 3</label>
              <input v-model="localTitles[2]" type="text" class="form-control" required>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'EditParameterNamesModal',
  props: {
    titles: {
      type: Array,
      default: () => ['', '', '']
    }
  },
  data() {
    return {
      localTitles: [...this.titles],
      modal: null
    };
  },
  mounted() {
    this.modal = new Modal(document.getElementById('editParameterNamesModal'));
  },
  methods: {
    open() {
      this.localTitles = [...this.titles]; // синхронизируем с текущими пропсами
      this.modal.show();
    },
    close() {
      this.modal.hide();
    },
    save() {
      this.$emit('save', [...this.localTitles]);
      this.close();
    }
  }
};
</script>